import React, { useState, useEffect } from 'react';
import axios from '@helpers/axios/private.axios';
import { Box } from '@mui/material';

const LogItem = ({ log }) => {
  const isSuccess = log.status === 'success';
  return (
    <div className="table__tr">
      <Box sx={{ flex: '1 0 15%' }} className="table__td">{log.created_at}</Box>
      <Box sx={{ flex: '1 0 15%' }} className="table__td">{log.campaign_name || 'Global'}</Box>
      <Box sx={{ flex: '1 0 10%' }} className="table__td">{log.event}</Box>
      <Box sx={{ flex: '1 0 30%', overflow: 'hidden', textOverflow: 'ellipsis' }} className="table__td" title={log.url_sent}>{log.url_sent}</Box>
      <Box sx={{ flex: '1 0 10%', display: 'flex', alignItems: 'center' }} className="table__td">
        <span className={`status-badge ${isSuccess ? 'success' : 'failed'}`}>
          {log.status} ({log.response_code || 'N/A'})
        </span>
      </Box>
      <Box sx={{ flex: '1 0 20%', overflow: 'hidden', textOverflow: 'ellipsis' }} className="table__td" title={log.response_body}>
        {log.response_body || 'No response body'}
      </Box>
    </div>
  );
};

export const PostbackLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const resp = await axios.get('/postbacks/logs');
        setLogs(resp.data.data);
      } catch (error) {
        console.error("Failed to fetch postback logs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  return (
    <div className="table">
      <div className="table__tr table__tr--head">
        <Box sx={{ flex: '1 0 15%' }} className="table__td">Date</Box>
        <Box sx={{ flex: '1 0 15%' }} className="table__td">Campaign</Box>
        <Box sx={{ flex: '1 0 10%' }} className="table__td">Event</Box>
        <Box sx={{ flex: '1 0 30%' }} className="table__td">URL Sent</Box>
        <Box sx={{ flex: '1 0 10%' }} className="table__td">Status</Box>
        <Box sx={{ flex: '1 0 20%' }} className="table__td">Response</Box>
      </div>
      {loading ? <p style={{ textAlign: 'center', padding: '20px' }}>Loading logs...</p> :
        logs.length > 0 ? logs.map(log => <LogItem key={log.id} log={log} />) :
          <div style={{ textAlign: 'center', padding: '40px', background: '#202020', borderRadius: '8px', marginTop: '10px' }}>
            <h3>No Logs Found</h3>
            <p>When a postback is triggered, a log of the attempt will appear here.</p>
          </div>
      }
    </div>
  );
};